import * as commWebApi from '@/api/modules/commWebApi';
import $store from '@/store/index';
import { franc } from 'franc';

const langOptions = [
  { label: '简体中文', value: 'Simplified Chinese', identifier: 'cmn' },
  { label: 'English', value: 'English', identifier: 'eng' },
];

const containsChineseCharacters = (str) => {
  const chineseRegex = /[\u4E00-\u9FFF]/;
  return chineseRegex.test(str);
};

// horn 配置
let cache: any = [];

window.$Horn.fetch('chinese_english_mapping').then((res) => {
  cache = res.languageMap;
});

const detectLanguage = (text) => {
  let detectedLang = franc(text, { minLength: 1 });
  /*
   * detectedLang === 'sco'
   * || detectedLang === 'mad'
   * || detectedLang === 'uzn'
   * || detectedLang === 'bam'
   * || detectedLang === 'bug'
   * || detectedLang === 'ilo'
   * || detectedLang === 'ces'
   * || detectedLang === 'fra'
   */
  if (detectedLang !== 'cmn' && detectedLang !== 'und' && !containsChineseCharacters(text)) detectedLang = 'eng';
  const foundLang = langOptions.find((lang) => lang.identifier === detectedLang);
  return foundLang ? foundLang.value : detectedLang;
};

const getTextNodeIndex = (textNode) => {
  const parent = textNode.parentNode;
  let index = 0;
  let found = false;

  if (parent) {
    parent.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        if (node === textNode) {
          found = true;
        }

        if (!found) {
          index++;
        }
      }
    });
  }

  return index;
};

const replaceTextWithPseudo = async (textNode) => {
  const parentNode = textNode.parentElement;
  const originalText = textNode.textContent;
  parentNode.dataset.originalTextAll = 'dom';
  if (!cache.length) {
    const res = await window.$Horn.fetch('chinese_english_mapping');
    cache = res.languageMap;
  }

  const cachelocal = cache.find((item) => item.zh.trim() === originalText.trim());
  if (cachelocal) {
    textNode.textContent = ` ${cachelocal.en} `;
    parentNode.dataset[`originalText${getTextNodeIndex(textNode)}`] = originalText;
    return;
  }

  const sourceLang = detectLanguage(originalText);
  // 如果源语言与目标语言相同，跳过翻译
  if (sourceLang === 'English') return;
  const cacheAiTarget = window.$langCache.find((item) => item.text.trim() === originalText.trim());
  textNode.textContent = ` ${cacheAiTarget?.translatedText || ' error '} `;
  parentNode.dataset[`originalText${getTextNodeIndex(textNode)}`] = originalText;
};

const filterUniqueByZh = (array1, array2) => {
  const zhSet = new Set(array2.map((item) => item.text));
  const addNew = [...new Set(array1.map((item) => item.zh))];
  return addNew.filter((item) => !zhSet.has(item)).map((item) => ({ zh: item }));
};

let timer: any = null;

export const changeLang = async (inquire = false) => {
  $store.commit('langLoadingChange', true);
  if (timer) clearTimeout(timer);
  return new Promise((resolve) => {
    try {
      timer = setTimeout(async () => {
        const lang = window.$lang;
        if (inquire) {
          if (lang === 'English') await translate('English');
          $store.commit('langLoadingChange', false);
          return resolve('');
        }

        if (lang === 'English') {
          window.$lang = 'Simplified Chinese';
          $store.commit('langChange', 'Simplified Chinese');
          replaceTextWithOriginal();
        } else if (lang === 'Simplified Chinese') {
          window.$lang = 'English';
          $store.commit('langChange', 'English');
          await translate(window.$lang);
        }

        resolve('');
        setTimeout(() => {
          $store.commit('langLoadingChange', false);
        });
      }, 300);
    } catch {
      resolve('');
      $store.commit('langLoadingChange', false);
    }
  });
};

const replaceTextWithOriginal = () => {
  const elements = document.querySelectorAll('[data-original-text-all]');
  elements.forEach((element) => {
    const textNodes = Array.from(element.childNodes).filter((node) => node.nodeType === Node.TEXT_NODE);
    textNodes.forEach((textNode) => {
      const originalText = element.getAttribute(`data-original-text${getTextNodeIndex(textNode)}`);
      // 保存当前文字节点的内容到 data-original-text
      const currentText: any = textNode.textContent;
      element.setAttribute(`data-original-text${getTextNodeIndex(textNode)}`, currentText);
      textNode.textContent = originalText;
    });
  });
};

export const translate = async (lang) => {
  let domAll: any = document.body.querySelectorAll('*:not(script):not(noscript):not(style):not(deepl-input-controller):not(.no-translation-tag)');
  const processedTexts = new Set();
  const uniqueTextNodes: any = [];
  const getTextNodes = (element) => {
    const textNodes: any = [];
    const traverse = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const sourceLang = detectLanguage(node.textContent);
        // 如果源语言与目标语言相同，跳过翻译
        if (sourceLang === lang || sourceLang === 'und') return;
        textNodes.push(node);
      } else {
        if (node.classList?.contains('no-translation-tag')) return;
        node.childNodes.forEach((child) => traverse(child));
      }
    };

    traverse(element);
    return textNodes;
  };

  [...domAll].forEach((element) => {
    const textNodes = getTextNodes(element);
    textNodes.forEach((node) => {
      const textContent = node.textContent.trim();
      if (textContent.length > 0 && !processedTexts.has(textContent)) processedTexts.add(textContent);
      uniqueTextNodes.push(node);
    });
  });

  const params = uniqueTextNodes.map((item, index) => ({ zh: item.textContent, id: index })).filter((item) => item.zh.trim());
  // const neverQuery = filterUniqueByZh(params, $store.state.langCache);
  const neverQuery = filterUniqueByZh(params, window.$langCache);
  /*
   * $store.commit('langCacheChange', neverQuery);
   * window.$langCache = window.$langCache.concat(neverQuery);
   */

  // neverQuery 做请求 neverQuery没有新增了请求不再继续， 函数继续执行更新翻译；
  if (neverQuery.length) {
    const textList: any = neverQuery.map((item, id) => ({
      id,
      text: item.zh,
      language: 'ZH_TO_EN',
    }));

    const res: any = await commWebApi.postCommWebApiModelTranslation({ textList });
    if (res.data) window.$langCache = window.$langCache.concat(res.data.textList);
  }

  return new Promise((resolve) => {
    uniqueTextNodes.forEach((item) => {
      replaceTextWithPseudo(item);
    });
    domAll = null;
    resolve('');
  });
};
